import React, { useEffect, useState } from 'react';
import { apiGet } from '../../../API/Api_Url';
import { X, MapPin, Calendar, DollarSign, FileCheck } from 'lucide-react';
import { FaCheckCircle, FaEdit, FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function UserAllFreelancerSelectedJobPost({ RequirementState, setRequirementState }) {
    const navigate = useNavigate();
    const [FreelancerJobPost, setFreelancerJobPost] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetUserAllFreelancerSelectedJobPost = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/user/UserGetAllFreelancerSelectedJobPost');
            setFreelancerJobPost(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetUserAllFreelancerSelectedJobPost();
    }, []);

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Approved':
            case 'Accepted':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            My All Freelancer Job Posts
                        </h1>
                        <p className="text-gray-600">Manage and track your freelancer job posts</p>
                    </div>

                    <div className="mt-4 md:mt-0">
                        <select
                            value={RequirementState}
                            onChange={(e) => setRequirementState(e.target.value)}
                            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0060B9]"
                        >
                            <option value="All">All</option>
                            <option value="pending">Pending</option>
                            <option value="Selected">Selected</option>
                            <option value="AgreementPending">Agreement Pending</option>
                            <option value="InConstruction">In Construction</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>
                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : FreelancerJobPost?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Freelancer Job Posts found.</p>
                        <p className="text-gray-400 mt-2">Create your first job post to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {FreelancerJobPost?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">{req?.Title}</h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(req?.Status)}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>

                                <p className="text-gray-700 mb-3">{req?.Description}</p>

                                {req?.Skillsrequire?.length > 0 && (
                                    <p className="text-sm text-gray-600 mb-3">
                                        <span className="font-medium">Skills Required:</span> {req?.Skillsrequire.join(', ')}
                                    </p>
                                )}

                                <div className="grid grid-cols-2 gap-4 text-sm mb-4">
                                    <div className="flex items-center text-gray-700">
                                        <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                        <p><span className="font-medium">Budget:</span> ₹{req?.Budget}</p>
                                    </div>

                                    <div className="flex items-center text-gray-700">
                                        <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                        <p><span className="font-medium">Timeline:</span> {formatDate(req?.timeline?.startDate)} - {formatDate(req?.timeline?.endDate)}</p>
                                    </div>
                                </div>

                                {req?.location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">{req?.location?.Address}, {req?.location?.City}, {req?.location?.State}</p>
                                    </div>
                                )}

                                <div className="mt-4 bg-gray-50 p-4 rounded-lg border text-sm text-gray-700 space-y-2">
                                    <p>Freelance Agreement: {req?.FreelanceEngineerAgreementRequest}</p>
                                    <p>User Agreement: {req?.UserAgreementRequest}</p>
                                </div>

                                <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>

                                    <button
                                        // onClick={() => navigate(`/FreelancerJobPostDetail/${req?._id}`)}
                                        className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                                    >
                                        <FaEye className="h-4 w-4" /> View Details
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default UserAllFreelancerSelectedJobPost;
